import moment from "moment";

export default {
	name: "indexView",
	data() {
		return {
			navList: [],
			bannerList: [],
			subjectList: [],
			specList: [],
			courseData: {},
			erweimaList: []
		};
	},
	watch: {},
	created() {
		console.log("index created");
		const menuList = JSON.parse(localStorage.getItem("menuList"));
		console.log("menuList", menuList);
		if (menuList && menuList.data) {
			this.navList = menuList.data;
			console.log("this.navList", this.navList);
		}
	},
	async mounted() {
		await this.getSubjectData();
		await this.getBannerList();
		await this.getCourseData();
		await this.getErweimaList();

		// await this.getBoutiqueData();
		// await this.getFreeData();
	},
	onUpdated() {},
	beforeDestroy() {},
	methods: {
		async getSubjectData() {
			const courseRes = await this.$zkHttp.index$get_subject();
			console.log("courseRes", courseRes);
			this.subjectList = courseRes;
		},
		async getCourseData() {
			const courseRes = await this.$zkHttp.index$getIndexCourse();
			console.log("courseRes", courseRes);
			if (courseRes) {
				this.courseData = courseRes || {};
				// let zhuanti = [],
				// 	jingpin = [],
				// 	mianfei = [];
				// if (courseRes.zhuanti && courseRes.zhuanti.length) {
				// 	for (let i = 0; i < 8; i++) {
				// 		zhuanti.push(courseRes.zhuanti[i] || {});
				// 	}
				// }
				// if (courseRes.jingpin && courseRes.jingpin.length) {
				// 	for (let i = 0; i < 8; i++) {
				// 		jingpin.push(courseRes.jingpin[i] || {});
				// 	}
				// }
				// if (courseRes.mianfei && courseRes.mianfei.length) {
				// 	for (let i = 0; i < 8; i++) {
				// 		mianfei.push(courseRes.mianfei[i] || {});
				// 	}
				// }
				// this.courseData.zhuanti = zhuanti;
				// this.courseData.jingpin = jingpin;
				// this.courseData.mianfei = mianfei;
			}
			console.log("this.courseData", this.courseData);
		},
		async getBoutiqueData() {
			const courseRes = await this.$zkHttp.index$get_course({
				is_free: 2,
				course_type_id: 1,
				teacher: '',
				price: '',
				create_at: 'asc',
				tag: '精品'
			});
			console.log("courseRes", courseRes);
			this.courseList = courseRes;
		},
		async getFreeData() {
			const freeRes = await this.$zkHttp.index$get_course({
				is_free: 1,
				course_type_id: 1,
				teacher: '',
				price: '',
				create_at: 'asc',
				tag: '精品'
			});
			console.log("freeRes", freeRes);
			this.freeList = freeRes;
		},
		async getBannerList() {
			const carouselRes = await this.$zkHttp.index$carousel();
			console.log("carouselRes", carouselRes);
			this.bannerList = carouselRes || [];
		},
		async getErweimaList() {
			const erweimaRes = await this.$zkHttp.index$get_erweima();
			console.log("erweimaRes", erweimaRes);
			this.erweimaList = erweimaRes || [];
		},
		clickItem(e) {
			// alert(e.name);
			// const pageList = ['', 'course', 'lecturer', 'student', 'free', 'honor', 'about'];
			if (e.name === '定制课程') {
				this.$message({
					showClose: true,
					message: '定制课程(开发中)',
					duration: 6000,
				});
			} else if (e.url) {
				this.toNext(e.url);
			}
		},
		toNext(page) {
			console.log("toNext page = ", page);
			this.$router.push(`/${page}`);
		},
		toList(current) {
			this.$router.push(`/column?current=${current}`);
		},
		toListWithSubj(subj) {
			this.$router.push(`/column?current=column&subjId=${subj.subject_id}`);
		},
		gotoDetail(e, type) {
			if (type == 'special') {
				this.$router.push({
					name: 'columnDetail',
					query: {
						parent: 'home',
						special_id: e.id
					}
				});
			} else if (type == 'course') {
				this.$router.push({
					name: 'courseDetail',
					query: {
						parent: 'home',
						course_id: e.course_id
					}
				});
			}
		},
	},
};